import React from 'react';

import Tooltip from 'shared/components/Tooltip';
import Label from 'shared/components/Label';
import TextInput from 'shared/components/TextInput';

const Qty = (props) => <TextInput {...props} />;

const Quantities = (props) => {
  const {
    parameters,
    errorMessage,
    tooltip,
    disabled,
    required,
    label,
    onChangeParameter,
    groupName,
    nameQty1,
    nameQty2,
    nameQty3,
    nameQty4,
  } = props;

  const name = 'quantities';
  const [qty1, qty2, qty3, qty4] = parameters[name];
  return (
    <div className="form-group">
      <Label label={label} required={required} />
      <Tooltip id="tooltip-qty" title={tooltip} />
      <div className="row">
        <div className="col-3">
          <Qty
            groupName={groupName}
            name={nameQty1}
            onChange={(e) => onChangeParameter('qty1', e.target.value)}
            disabled={disabled}
            value={qty1} />
        </div>
        <div className="col-3">
          <Qty
            groupName={groupName}
            name={nameQty2}
            onChange={(e) => onChangeParameter('qty2', e.target.value)}
            disabled={disabled}
            value={qty2} />
        </div>
        <div className="col-3">
          <Qty
            groupName={groupName}
            name={nameQty3}
            onChange={(e) => onChangeParameter('qty3', e.target.value)}
            disabled={disabled}
            value={qty3} />
        </div>
        <div className="col-3">
          <Qty
            groupName={groupName}
            name={nameQty4}
            onChange={(e) => onChangeParameter('qty4', e.target.value)}
            disabled={disabled}
            value={qty4} />
        </div>
      </div>
      <div className="error">
        {errorMessage}
      </div>
    </div>
  );
};

Quantities.defaultProps = {
  label: Spree.translations.parameters.quantities,
  tooltip: Spree.helpForParameters.quantities,
  nameQty1: '',
  nameQty2: '',
  nameQty3: '',
  nameQty4: '',
  groupName: 'parameters[quantities]',
  layout: 'inline',
};

export default Quantities;
